import { Flex } from '@abyss/web/ui/Flex';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Text } from '@abyss/web/ui/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../common/AdobeTagging/adobeLinkTrackEvent';
import { useCurrentMemberIsPreEffective } from '../../../hooks/useCurrentMemberIsPreEffective/useCurrentMemberIsPreEffective';
import {
  StyledLeftIconAndLink,
  StyledLink,
  StyledTextLabelGetCost,
} from '../VirtualCare.styled';

interface CostEstimateLinkProps {
  additionalStyles?: React.CSSProperties;
  adobeLinkTrackLocation: string;
  costEstimate?: {
    title?: string;
    url?: string;
  } | null;
  testId: string;
}

export const VirtualCareCostEstimateLink: React.FC<CostEstimateLinkProps> = ({
  additionalStyles,
  adobeLinkTrackLocation,
  costEstimate,
  testId,
}) => {
  const { t } = useTranslation();
  const isPreEffective = useCurrentMemberIsPreEffective();
  if (!costEstimate?.url || !costEstimate?.title) {
    return null;
  }

  return (
    <Flex
      css={{
        gap: '16px',
        alignItems: 'center',
        ...additionalStyles,
      }}
      direction="row"
    >
      <Text
        css={{
          color: 'black',
          fontFamily: 'UHC2020 Sans',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '18px',
          margin: 0,
        }}
      >
        {t('VIRTUAL_PROVIDERS_SECTION.YOU_PAY')}
      </Text>
      <StyledLink data-testid={testId}>
        <StyledLeftIconAndLink>
          <StyledTextLabelGetCost
            disabled={isPreEffective}
            href={`${costEstimate?.url}`}
            onClick={(e) => {
              if (isPreEffective) e.preventDefault();
              adobeLinkTrackEvent({
                name: costEstimate?.title,
                location: adobeLinkTrackLocation,
                type: 'internal',
                destinationUrl: `${costEstimate?.url}`,
              });
            }}
            rel="noopener noreferrer"
            target="_blank"
          >
            {costEstimate?.title}
          </StyledTextLabelGetCost>
          <IconSymbol
            color={isPreEffective ? '$gray' : '#002677'}
            disabled={isPreEffective}
            icon="chevron_right"
            isScreenReadable
          />
        </StyledLeftIconAndLink>
      </StyledLink>
    </Flex>
  );
};
